// extracted by mini-css-extract-plugin
export var copyableField = "_pl-4";
export var customerBadge = "_pl-0";
export var customerInfoTitle = "_pl-2";
export var details = "_pl-1";
export var dropdownContainer = "_pl-5";
export var dropdownImage = "_pl-6";
export var editAssigneeForm = "_pl-a";
export var editButton = "_pl-3";
export var email = "_pl-7";
export var hidden = "_pl-d";
export var input = "_pl-8";
export var saveButton = "_pl-b";
export var shopifyIcon = "_pl-c";
export var suggestionBadge = "_pl-e";
export var suggestionText = "_pl-f";
export var username = "_pl-9";